import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { FeedbackDetailModal } from '../components/FeedbackDetailModal';
import { useFeedbacks } from '../hooks';
import type { Feedback } from '../../../shared/lib/api';
import { formatBrasilia } from '../../../shared/lib/date';

const MeusFeedbacksPage: React.FC = () => {
  const { data, isLoading, isError, error } = useFeedbacks();
  const feedbacks = data?.data ?? [];
  const [detailFeedback, setDetailFeedback] = useState<Feedback | null>(null);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Meus Feedbacks</h1>

      {isLoading ? (
        <div>Carregando...</div>
      ) : isError ? (
        <div className="text-red-600">Erro: {(error as Error)?.message}</div>
      ) : feedbacks.length === 0 ? (
        <div className="p-8 text-center bg-gray-50 rounded-xl border border-gray-200">
          <MessageSquare className="w-10 h-10 text-gray-300 mx-auto mb-3" />
          <p className="text-sm text-gray-500">Você ainda não recebeu nenhum feedback.</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gestor</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Período</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data/Hora</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {feedbacks.map(fb => (
                <tr
                  key={fb.id}
                  className="hover:bg-gray-50 transition-colors cursor-pointer"
                  onClick={() => setDetailFeedback(fb)}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {fb.manager?.name ?? fb.managerId}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{fb.referencePeriod}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {formatBrasilia(fb.createdAt)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {detailFeedback && (
        <FeedbackDetailModal feedback={detailFeedback} onClose={() => setDetailFeedback(null)} />
      )}
    </div>
  );
};

export default MeusFeedbacksPage;
